__turbopack_context__.v({
  "cover": "album-grid-module__OLxc9q__cover",
  "grid": "album-grid-module__OLxc9q__grid",
  "lines": "album-grid-module__OLxc9q__lines",
  "shade": "album-grid-module__OLxc9q__shade",
});
